// Any config specific to QATAR?

export default {
  code: 'QA',
  countryName: 'Qatar',
  googleSiteVerificationCode: [
    'wtxpKlm6JDPBJ26AlP2MK7QBzSu4w3uft86J2PNihw0',
    'fj8tOPQ-f_Vhb1NzN9O_7AsBag79792HVC5hCB-qu1o',
    'NIdCZIeFh92oVESIs9QH9kQQz8R_ZjJXLKUyLpB9jns'
  ],
  countryDomain: 'https://www.carrefourqatar.com',
  helplineNumber: '8007322',
  latitude: 25.36856,
  longitude: 51.551438,
  countryFlagIcon: 'QA_b4310ae52c.png',
  defaultAreaCode: 'The Pearl - Doha',
  features: {
    languageChange: true,
    now: false,
    share: false,
    isLocationCXEnable: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '77eca38d-d159-4a71-946e-238e13266530'
  },
  metaVerificationTag: 'ecd16c474b'
}
